import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { memo, useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import Navbar from "../common/Navbar";
import { Helmet } from "react-helmet";
import LoadingScreen from "../common/loader";
import Cursor from "../common/cusor";
import ProgressScroll from "../common/ProgressScroll";
import Lines from "../common/Lines";
import appContext from "../../context/AppContext";
import Footer from "../common/Footer";

const loadFile = async (pdfFileName) => {
  const module = await import(
    `../../../public/assets/pdf/case-studies/${pdfFileName}.pdf`
  );
  return module.default;
};

const PDFViewer = () => {
  const context = useContext(appContext);
  const setIndex = context.setIndex;
  const params = useParams();
  const fileName = params.pdfName || "sample";
  const [fileUrl, setFileUrl] = useState("");
  useEffect(() => {
    const loadFileData = async () => {
      try {
        if (fileUrl) return;
        const fileLoaded = await loadFile(fileName);
        setFileUrl(fileLoaded);
        document.title = `Viewing PDF: ${fileName}.pdf`;
      } catch (error) {
        console.error(`Error loading PDF file: ${fileName}.pdf`, error);
      }
    };
    loadFileData();
  }, [fileName, fileUrl]);
  if (!fileUrl)
    return <div className="page-not-found">Case study not found!</div>;
  return (
    <>
      <Helmet>
        <title>Nithin Namani</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script defer src="/assets/js/gsap.min.js"></script>

        <script defer src="/assets/js/splitting.min.js"></script>
        <script defer src="/assets/js/isotope.pkgd.min.js"></script>
        <script defer src="/assets/js/plugins.js"></script>
        <script defer src="/assets/js/TweenMax.min.js"></script>
        <script defer src="/assets/js/charming.min.js"></script>
        <script defer src="/assets/js/countdown.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar handleSectionClick={setIndex} />
        <div
          className="container"
          style={{
            // height: `${availableHeight}px`,
            paddingTop: `${72}px`,
          }}
        >
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer fileUrl={fileUrl} />
          </Worker>
        </div>
        <Footer handleSectionClick={setIndex} />
      </body>
    </>
  );
};
export default memo(PDFViewer);
